import __request__ from "routing/request";
export function download(filename) {
  return __request__("GET", `/system/debug/support/bundle/download/${filename}`, null, {}, {
    "Accept": ["application/octet-stream"]
  });
}
export function listBundles() {
  return __request__("GET", "/system/debug/support/bundle/list", null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(filename) {
  return __request__("DELETE", `/system/debug/support/bundle/${filename}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getLogFile(id) {
  return __request__("GET", `/system/debug/support/logfile/${id}`, null, {}, {
    "Accept": ["application/octet-stream"]
  });
}
export function getNodeManifest() {
  return __request__("GET", "/system/debug/support/manifest", null, {}, {
    "Accept": ["application/json"]
  });
}
